import { defineComponent as r, renderSlot as o, openBlock as t, createBlock as p, Teleport as l } from "vue";
import { teleportProps as s } from "./index644.js";
var m = /* @__PURE__ */ r({
  __name: "teleport",
  props: s,
  setup(a) {
    return (e, n) => e.disabled ? o(e.$slots, "default", { key: 0 }) : (t(), p(l, {
      key: 1,
      to: e.to
    }, [
      o(e.$slots, "default")
    ], 8, ["to"]));
  }
});
export {
  m as default
};
